const { useEffect } = require('react');
const { isSearchShortcut } = require('./globalSearchHelpers');

/**
 * Calls `onTrigger` on Cmd + K (mac) or Ctrl + K (win/linux), anywhere in the
 * app. The default is prevented because Ctrl/Cmd + K is bound to the browser
 * address bar in Firefox — so when `enabled` is false nothing is bound at all,
 * leaving the browser shortcut untouched for users without the feature.
 */
const useGlobalSearchShortcut = (onTrigger, enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (!isSearchShortcut(event)) {
        return;
      }
      event.preventDefault();
      onTrigger();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [enabled, onTrigger]);
};

module.exports = useGlobalSearchShortcut;
